import * as React from "react";
const SvgFiRrOtp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14.707 19.707 13.414 21l1.293 1.293a.999.999 0 1 1-1.414 1.414L12 22.414l-1.293 1.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L10.586 21l-1.293-1.293a.999.999 0 1 1 1.414-1.414L12 19.586l1.293-1.293a.999.999 0 1 1 1.414 1.414M21.414 21l1.293-1.293a.999.999 0 1 0-1.414-1.414L20 19.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L18.586 21l-1.293 1.293a.999.999 0 1 0 1.414 1.414L20 22.414l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414zM6.707 18.293a1 1 0 0 0-1.414 0L4 19.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L2.586 21l-1.293 1.293a.999.999 0 1 0 1.414 1.414L4 22.414l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L5.414 21l1.293-1.293a1 1 0 0 0 0-1.414M18 11c0 2.206-1.794 4-4 4h-4c-2.206 0-4-1.794-4-4V9c0-1.474.81-2.75 2-3.444V4c0-2.206 1.794-4 4-4s4 1.794 4 4v1.556c1.19.694 2 1.97 2 3.444zm-8-6h4V4c0-1.103-.897-2-2-2s-2 .897-2 2zm6 4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2zm-4-.5a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0 0-3.001"
    />
  </svg>
);
export default SvgFiRrOtp;
